<template>

  <div>
    <LDBsTable
      url="extracts"
      defaultSort="id"
      defaultOrder="desc"
      :query="query"
      :columns="columns"
      :clear="clear"
      :defaultOptions='options'
    >
      <div class="form-group col-lg-4">
        <label for="extract">{{ $t('extract') }}</label>
        <input
          type="text"
          id="extract"
          name="extract"
          class="form-control"
          :placeholder="$t('ph_extract')"
          v-model="query.id"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
        <Combobox
          class="bg-white"
          name='garage_accredited'
          :placeholder="$t('select_a_item')"
          :options="garages"
          :initial-value="query.garageAccredited"
          label="fantasyName"
          v-model="query.garageAccredited"
          :reduce="garage => garage.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="user">{{ $t('user') }}</label>
        <Combobox
          class="bg-white"
          name='user'
          :placeholder="$t('select_a_item')"
          :options="users"
          :initial-value="query.user"
          label="name"
          v-model="query.user"
          :reduce="user => user.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="os">{{ $t('OS') }}</label>
        <input
          type="text"
          id="os"
          name="os"
          class="form-control"
          :placeholder="$t('ph_os')"
          v-model="query.os"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="payment_voucher">{{ $t('payment_voucher') }}</label>
        <vue-select
          class="bg-white"
          name='payment_voucher'
          :placeholder="$t('select_a_item')"
          :initial-value="query.paymentVoucher"
          label="label"
          :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false }]"
          v-model="query.paymentVoucher"
          :reduce="paymentVoucher => paymentVoucher.value"
          :select-on-tab='true'
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="email_sent">{{ $t('email_sent') }}</label>
        <vue-select
          class="bg-white"
          name='email_sent'
          :placeholder="$t('select_a_item')"
          :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false }]"
          :initial-value="query.emailSent"
          label="label"
          v-model="query.emailSent"
          :reduce="emailSent => emailSent.value"
          :select-on-tab='true'
        />
      </div>
    </LDBsTable>

    <!-- MODAL TABLE -->
    <div
      ref='modalOs'
      id="myModal"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModal"
      aria-hidden="true"
    >
      <div class="modal-xl modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel"></h5>
          </div>

          <div class="modal-body">
            <b-alert
              :show="alert.show"
              @dismissed='alert.show = false'
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <div class="row">
              <div class="form-group col-lg-6">
                <label for="reason_extra_value">{{ $t('reason_extra_value') }}</label>
                <input
                  type="reason_extra_value"
                  class="form-control"
                  id="reason_extra_value"
                  name="reason_extra_value"
                  :placeholder="$t('ph_reason_extra_value')"
                  v-model="reasonExtraValue"
                >
              </div>

              <div class="form-group col-lg-6">
                <label for="extra_value_not_linked_os">{{ $t('extra_value_not_linked_os') }}</label>
                <CurrencyInput
                  v-model="extraValueNotLinkedOs"
                  :auto-decimal-mode="true"
                  :distraction-free='false'
                  currency='BRL'
                  locale='pt-BR'
                  class="demo__currency-input form-control"
                />
              </div>
            </div>

            <b-table
              id='tableModal'
              responsive='xl'
              bordered
              hover
              :fields="fieldsSubTable"
              :items='finishedOsFiltered'
              class="bg-white"
              :busy='busy'
            >
              <template v-slot:cell(serial)=value>
                {{ getInfoIdAndEquipment(value) }}
              </template>

              <template v-slot:cell(client)=value>
                <Combobox
                  :id="'contractId'+value.item.id"
                  class="bg-white"
                  name='contract'
                  :options="contracts"
                  :initial-value='value.item.contract'
                  label='contracts'
                  v-model="clients[value.index]"
                  :reduce='contract => contract.id_contrato'
                />
              </template>

              <template v-slot:cell(testDate)=value>
                {{ formatDate(value.item.testDate) }}
              </template>

              <template v-slot:cell(service_value)=value>
                <CurrencyInput
                  :id="'serviceValue'+value.item.id"
                  :value='value.item.serviceValue'
                  currency='BRL'
                  :distraction-free='false'
                  :auto-decimal-mode='true'
                  locale='pt-BR'
                  class="demo__currency-input form-control"
                  style='width: 120px'
                />
              </template>

              <template v-slot:cell(travel_value)=value>
                <CurrencyInput
                  :id="'travelValue'+value.item.id"
                  :value='value.item.travelValue'
                  currency='BRL'
                  :distraction-free='false'
                  :auto-decimal-mode='true'
                  locale='pt-BR'
                  class="demo__currency-input form-control"
                  style='width: 120px'
                />
              </template>

              <template v-slot:cell(extra_value)=value>
                <CurrencyInput
                  :id="'extraValue'+value.item.id"
                  :value='value.item.extraValue'
                  currency='BRL'
                  :distraction-free='false'
                  :auto-decimal-mode='true'
                  locale='pt-BR'
                  class="demo__currency-input form-control"
                  style='width: 120px'
                />
              </template>

              <template v-slot:cell(idOs)=value>
                <b-button
                  variant='danger'
                  pill
                  @click="removeOs(value.item.id)"
                >
                  <i class="fas fa-trash" />
                </b-button>
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-secondary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong> Carregando...</strong>
                </div>
              </template>
            </b-table>

            <div class="row text-right">
              <div class="col-12">
                <b-button class="mt-3" id='closeModal' data-dismiss="modal">{{ $t('close') }}</b-button>
                <b-button class="mt-3 ml-2" variant='primary' @click="save">{{ $t('save') }}</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL UPLOAD -->
    <div
      ref='modalUpload'
      id="modalUpload"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalUpload"
      aria-hidden="true"
    >
      <div class="modal modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalUploadLabel"></h5>
          </div>

          <div class="modal-body">
            <b-alert
              :show="alert.show"
              @dismissed='alert.show = false'
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <div class="row">
              <div class="col">
                <b-form-file
                  v-model="file"
                  :state="Boolean(file)"
                  placeholder="Selecione o comprovante..."
                  drop-placeholder="Drop file here..."
                  accept='.pdf'
                  browse-text='Buscar'
                />
              </div>
            </div>

            <br />

            <div class="row">
              <div class="col">
                <b-form-checkbox
                  id="sendEmail"
                  v-model="sendEmail"
                  name="sendEmail"
                  value="true"
                  unchecked-value="false"
                >
                  Enviar e-mail ao Técnico/Oficina Credenciada
                </b-form-checkbox>
              </div>
            </div>

          </div>

          <div class="col-12 text-right modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
              :disabled='busy'
            >
              {{ $t('close') }}
            </b-button>
            <b-button
              :disabled='!file || busy'
              class="mt-3 ml-2"
              variant='primary'
              @click="saveAttachment"
            >
              {{ !busy ? (`${$t('save')}`) : 'Salvando...' }}
              <b-spinner v-show="busy" small></b-spinner>
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL SEND EMAIL -->
    <div
      ref='modalSendEmail'
      id="modalSendEmail"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalSendEmail"
      aria-hidden="true"
    >
      <div class="modal modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalSendEmailLabel"></h5>
          </div>

          <div class="modal-body">
            <b-alert
              :show="alert.show"
              @dismissed='alert.show = false'
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <p id='msgEmail'></p>
          </div>

          <div class="col-12 text-right modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
              :disabled='busy'
            >
              {{ $t('close') }}
            </b-button>
            <b-button
              :disabled='busy'
              class="mt-3 ml-2"
              variant='primary'
              @click="sendOrResendEmail"
            >
              {{ !busy ? (`${$t('send')}`) : 'Enviando...' }}
              <b-spinner v-show="busy" small></b-spinner>
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL INFO BANKS -->
    <div
      ref='modalInfo'
      id="modalInfo"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalInfo"
      aria-hidden="true"
    >
      <div class="modal modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalInfoLabel"></h5>
          </div>

          <div class="modal-body">
            <div class="row" v-if="!busy">
              <div class="col-12">
                <b-list-group v-for="item in bankAccount.rows" :key="item.id">
                  <b-list-group-item class="font-weight-bold">{{ item.bank.name + ' - Conta ' + item.type || '' }}</b-list-group-item>
                  <b-list-group-item>Agência: {{ item.agency +' | Conta: '+ item.account +' | PIX: ' + item.pix || '' }}</b-list-group-item>
                  <b-list-group-item>{{ item.name || '' }}</b-list-group-item>
                  <b-list-group-item>Fantasia: {{ item.garageAccredited.fantasyName || '' }}</b-list-group-item>
                  <b-list-group-item>CPF/CNPJ: {{ getCpfCnpj(item.cpfCnpj) || '' }}</b-list-group-item>
                </b-list-group>
              </div>
            </div>

            <div v-else>
              <div class="d-flex justify-content-center mb-3">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
          </div>

          <div class="col-12 text-right modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
              :disabled='busy'
            >
              {{ $t('close') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL LOADING -->
    <div
      ref='modalLoading'
      id="modalLoading"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalLoading"
      aria-hidden="true"
    >
      <div class="modal modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">Carregando...</h5>
          </div>

          <div class="modal-body">
            <div class="d-flex justify-content-center mb-3">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import { parse } from 'vue-currency-input'
import axios from 'axios'
import moment from 'moment-timezone'
import { maskCpfCnpj } from '@/lib/staticMask'
import { baseUrlReports } from '@/lib/config'

export default {
  name: 'OsList',
  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('extract'),
          field: 'id',
          width: '100%',
          sortable: true,
          visible: false
        },
        {
          title: this.$t('garage_accredited'),
          field: 'garageAccredited',
          formatter: function(value) {
            return value
              ? value.socialReason
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('fantasy_name'),
          field: 'garageAccredited',
          formatter: function(value) {
            return value
              ? value.fantasyName
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('date'),
          width: '100%',
          field: 'createdAt',
          formatter: function(value) {
            return moment(value).format('DD/MM/YYYY HH:mm:ss')
          },
          sortable: true
        },
        {
          title: this.$t('user'),
          width: '100%',
          field: 'user',
          formatter: function(value) {
            return value
              ? value.name
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('service_value'),
          field: 'serviceValue',
          width: '100%',
          align: 'right',
          formatter: value => {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          },
          sortable: true
        },
        {
          title: this.$t('travel_value'),
          field: 'travelValue',
          width: '100%',
          align: 'right',
          formatter: value => {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          },
          sortable: true
        },
        {
          title: this.$t('extra_value'),
          field: 'extraValue',
          width: '100%',
          align: 'right',
          formatter: (value, row) => {
            const sum = value + row.extraValueNotLinkedOs
            return sum.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          },
          sortable: true
        },
        {
          title: this.$t('total_value'),
          field: 'serviceValue',
          width: '100%',
          align: 'right',
          formatter: (value, row) => {
            const {
              serviceValue,
              travelValue,
              extraValue,
              extraValueNotLinkedOs
            } = row

            const sum = serviceValue + travelValue + extraValue + extraValueNotLinkedOs
            return sum.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          },
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '220px',
          formatter: function (value, row) {
            function getButtonType() {
              if (row.paymentVoucher) {
                return `<button
                  title="${row.emailSent ? 'Reenviar' : 'Enviar'} e-mail"
                  data-target="#modalSendEmail"
                  data-id='${value}'
                  data-toggle="modal"
                  data-whatever="${row.id}"
                  data-emailsent="${row.emailSent}"
                  data-garage="${row.garageAccredited.fantasyName}"
                  class="email mb-1 btn btn-action btn-${row.emailSent ? 'primary' : 'secondary'} btn-circle light-bottom-shadow text-white">
                  <i class="fas fa-envelope fa-lg" />
                </button>`
              } else {
                return `<button
                  disabled
                  title="${row.emailSent ? 'Reenviar' : 'Enviar'} e-mail"
                  data-target="#modalSendEmail"
                  data-id='${value}'
                  data-toggle="modal"
                  data-whatever="${row.id}"
                  data-emailsent="${row.emailSent}"
                  data-garage="${row.garageAccredited.fantasyName}"
                  class="email mb-1 btn btn-action btn-${row.emailSent ? 'primary' : 'secondary'} btn-circle light-bottom-shadow text-white">
                  <i class="fas fa-envelope fa-lg" />
                </button>`
              }
            }
            function getButtonTypePrintEmail() {
              if (row.paymentVoucher) {
                return `
                  <button
                    title="Imprimir Comprovante de Pagamento"
                    data-target="#modalLoading"
                    data-toggle="modal"
                    data-evt="paymentVoucher"
                    data-id='${value}'
                    data-whatever="${row.id}"
                    data-garage="${row.garageAccredited.fantasyName}"
                    class="edit mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
                  >
                    <i class="fas fa-file-invoice-dollar fa-lg" />
                  </button>`
              } else {
                return `<button
                  disabled
                  title="Imprimir Comprovante de Pagamento"
                  class="email mb-1 btn btn-action btn-secondary btn-circle light-bottom-shadow text-white">
                  <i class="fas fa-file-invoice-dollar fa-lg" />
                </button>`
              }
            }
            return `
              <button
                title="Editar"
                data-target="#myModal"
                data-id='${value}'
                data-toggle="modal"
                data-whatever="${row.id}"
                data-name='${row.garageAccredited.fantasyName}'
                data-notlinked='${row.notLinkedToOS}'
                class="edit mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white">
                <i class="fas fa-pen" />
              </button>
              <button
                value='${value}'
                data-whatever='${value}'
                data-toggle="modal"
                data-target="#modalLoading"
                title="Imprimir"
                class="printExtract mb-1 edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white">
                <i class="fas fa-print fa-lg" />
              </button>
              <button
                title="Anexar Comprovante de Pagamento"
                data-target="#modalUpload"
                data-id='${value}'
                data-toggle="modal"
                data-whatever="${row.id}"
                class="edit mb-1 btn btn-action btn-${row.paymentVoucher ? 'primary' : 'secondary'} btn-circle light-bottom-shadow text-white">
                <i class="fas fa-paperclip fa-lg" />
              </button>
              ${getButtonType()}
              ${getButtonTypePrintEmail()}
              <button
                title="Dados Bancários"
                data-target="#modalInfo"
                data-id='${value}'
                data-toggle="modal"
                data-whatever="${row.garageAccredited.id}"
                data-garage="${row.garageAccredited.fantasyName}"
                class="edit mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white">
                <i class="fas fa-info fa-lg" />
              </button>
            `
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'extratos' }
      },
      query: {
        id              : undefined,
        garageAccredited: undefined,
        user            : undefined,
        paymentVoucher  : undefined,
        emailSent       : false,
        os              : ''
      },
      extract: {
        id: '',
        contract: '',
        user: '',
      },
      alert: {
        show: false,
        type: '',
        message: ''
      },
      fieldsSubTable: [
        { key: 'serial', label: `OS / ${this.$t('serial')}`},
        { key: 'board', label: this.$t('board') },
        { key: 'client', label: this.$t('client') },
        { key: 'testDate', label: this.$t('finished_in') },
        { key: 'services.name', label: this.$t('services') },
        { key: 'service_value', label: this.$t('service_value') },
        { key: 'travel_value', label: this.$t('travel_value') },
        { key: 'extra_value', label: this.$t('extra_value') },
        { key: 'idOs', label: '' }
      ],
      busy: false,
      selected: [],
      reloadExtracts: false,
      clients: [],
      file: null,
      sendEmail: true,
      extractId: undefined,
      garages: [],
      reasonExtraValue: '',
      extraValueNotLinkedOs: 0,
      editingExtractNotLinkedToOS: false,
    }
  },

  computed: {
    ...mapState({
      extracts: state => state.extract.all,
      finishedOsFiltered: state => state.extract.finishedOsFiltered,
      structureExtractToPrint: state => state.extract.structureExtractToPrint,
      garagesStore: state => state.garageaccredited.all,
      users: state => state.users.all,
      contracts: state => state.contracts.all,
      bankAccount: state => state.bankaccount.all,
      extracts: state => state.extract.all,
      extractById: state => state.extract.extractById,
    }),

    optionsCurrency() {
      return {
        locale: 'pt-BR',
        currency: 'BRL'
      }
    }
  },

  methods: {
    clear() {
      this.query.id               = undefined
      this.query.garageAccredited = undefined
      this.query.user             = undefined
      this.query.paymentVoucher   = undefined
      this.query.emailSent        = undefined
      this.query.os               = ''
    },

    // SALVA ALTERAÇÕES REALIZADAS EM OS DO EXTRATO
    async save() {
      this.busy = true

      if (this.editingExtractNotLinkedToOS) {
        await this.$store.dispatch(
          'extract/edit',
          {
            notLinkedToOS: true,
            reasonExtraValue: this.reasonExtraValue,
            extraValueNotLinkedOs: this.extraValueNotLinkedOs,
            extractId: this.extractId
          }
        )
      } else {
        // MONTA OS OBJETOS DE CADA OS PARA SALVAR
        const data = this.finishedOsFiltered.map((e, index) => {
          // PEGA OS VALORES DE CADA OS
          let serviceValue = document.querySelector(`#serviceValue${e.id}`).value
          let travelValue = document.querySelector(`#travelValue${e.id}`).value
          let extraValue = document.querySelector(`#extraValue${e.id}`).value
          const contractId = this.clients[index]

          // MONTA OBJETO COM ID, VALORES (DATA), ID DA OFICIONA CREDENCIADA
          return {
            id: e.id,
            data: {
              serviceValue: parse(serviceValue, this.optionsCurrency) || 0,
              travelValue: parse(travelValue, this.optionsCurrency) || 0,
              extraValue: parse(extraValue, this.optionsCurrency) || 0,
              contractId,
              isExtract: true
            },
              garageId: e.garageAccredited.id
            }
        })

        data[0].reasonExtraValue      = this.reasonExtraValue
        data[0].extraValueNotLinkedOs = this.extraValueNotLinkedOs

        await this.$store.dispatch('extract/edit', data)
      }

      this.reloadExtracts = true

      // RECARREGA AS OS`S ATUALIZADAS
      await this.getAllOsOfExtract({
        id: this.extractId,
        notLinkedToOS: this.editingExtractNotLinkedToOS
      })

      this.alert = { show: true, type: 'success', message: 'Salvo com sucesso!' }

      this.busy = false
    },

    // REMOVE OS DO EXTRATO
    async removeOs(id) {
      const removed = await this.$store.dispatch('extract/removeOs', id)

      this.reloadExtracts = true

      if (removed)  await this.getAllOsOfExtract({ id: this.finishedOsFiltered[0].extractId })

      this.alert = { show: true, type: removed ? 'success' : 'danger', message: removed ? 'Os removida com sucesso!' : 'Erro ao remover OS' }

      this.busy = false
    },

    formatDate(date) {
      return moment(date).tz('America/Recife').format('DD/MM/YYYY')
    },

    // BUSCA TODAS AS OS`S E UM DETERMINADO EXTRATO
    // EXECUTA QUANDO CLICA EM EDITAR
    async getAllOsOfExtract({ id, notLinkedToOS = false }) {
      this.editingExtractNotLinkedToOS = notLinkedToOS

      this.busy = true

      const { dispatch } = this.$store

      if (notLinkedToOS) {
        await dispatch('extract/fetchById', id)

        if (this.extractById) {
          this.reasonExtraValue = this.extractById.reasonExtraValue
          this.extraValueNotLinkedOs = this.extractById.extraValueNotLinkedOs
        }
      } else {
        await dispatch('extract/fetchFinishedOsFiltered', { extractId: id } )

        // ARMAZENA O ID DE CADA OS
        this.finishedOsFiltered.map(e => { this.selected.push(e.id) })
      }

      this.busy = false
    },

    // GERAR RELATÓRIO DO EXTRATO
    async printExtract(id) {

      $('#table').bootstrapTable('showLoading')

      // PEGA A ESTRUTURA JSON DO PDF
      const result = await this.$store.dispatch('extract/fetchPrintExtract', { id })

      // FAZ REQUISIÇÃO AO MICROSERVIÇO DE GERAÇÃO DO PDF
      if (result) {

        axios({
          url         : baseUrlReports(),
          method      : 'post',
          data        : this.structureExtractToPrint,
          responseType: 'blob'
        })
          .then(response => {
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' }
            )
            const fileURL = URL.createObjectURL(file)
            window.open(fileURL, "_blank")
        })
          .catch(error => {
            console.log(error)
        })
          .then(busy => {
            $('#table').bootstrapTable('hideLoading')
            $('#modalLoading').modal('hide')
          })

      } else {
        $('#table').bootstrapTable('hideLoading')
        $('#modalLoading').modal('hide')
        this.$store.dispatch('notify/error', { message: 'errorWhenPrinting' }, { root: true })
      }
    },

    // UPLOAD DE COMPROVANTE DE PAGAMENTO
    async saveAttachment() {
      this.busy = true

      // PEGA O ANEXO E INSERE AO FORMDATA
      const formData = new FormData()
      formData.append('file', this.file)

      // MONTA OBJETO COM ID DO EXTRATO E SE É PRA ENVIAR E-MAIL OU NÃO
      const data = { sendEmail: this.sendEmail, extract: this.extractId }

      const uploaded = await this.$store.dispatch('extract/uploadPaymentVoucher', { formData, data })

      if (uploaded) this.reloadExtracts = true

      this.alert = {
        show: true,
        type: uploaded ? 'success' : 'danger',
        message: uploaded ? 'Comprovante anexado com sucesso!' : 'Erro ao anexar comprovante!'
      }
      this.busy = false
    },

    // ENVIA/REENVIA E-MAIL À OFICINA CREDENCIADA
    async sendOrResendEmail() {
      this.busy = true

      const send = await this.$store.dispatch('extract/sendEmail', { id: this.extractId })

      if (send) this.reloadExtracts = true

      this.alert = {
        show: true,
        type: send ? 'success' : 'danger',
        message: send ? `E-mail enviado com sucesso!` : 'Erro ao enviar e-mail!'
      }

      this.busy = false
    },

    getInfoIdAndEquipment({ item }) {

      const {
        id,
        services,
        withdrawnSerial,
        serial,
        equipmentUsedInReinstallation,
        requireSerial
      } = item

      let equipment = 0

      if (services.id === 2 || services.id === 6) {
        if (!requireSerial) {
          equipment = withdrawnSerial
        } else {
          equipment = equipmentUsedInReinstallation
            ? serial
            : withdrawnSerial
        }
      } else {
        equipment = services.id === 4
          ? withdrawnSerial
          : serial
      }

      return id +" / "+ equipment
    },

    async getBankData(id) {
      this.busy = true

      await this.$store.dispatch('bankaccount/fetchFiltered', { garageAccredited: id })

      this.busy = false
    },

    async getPaymentVoucher(id) {

      const url = `${process.env.VUE_APP_API_BASE_URL}print-payment-voucher?id=${id}`

      axios({
        url,
        method: 'GET',
        responseType: 'blob'
      })
        .then(response => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' }
          )
          const fileURL = URL.createObjectURL(file)
          window.open(fileURL, "_blank")
      })
        .catch(error => {
          console.log(error)
      })
        .then(() => {
          $('#modalLoading').modal('hide')
      })
    },

    getCpfCnpj(value) {
      return maskCpfCnpj(value)
    }

  },

  async mounted() {
    const { dispatch } = this.$store

    dispatch('overlay/show', true)

    await dispatch('contracts/fetchAll')
    await dispatch('garageaccredited/fetchAll')
    await dispatch('users/fetchAll')

    this.garages = this.garagesStore

    dispatch('overlay/show', false)

    const global = this
    // EXECUTA QUANDO MODAL EDITAR É ACIONADO
    $('#myModal').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      const modal = $(this)
      modal.find('.modal-title').text(`Extrato ${button.data('whatever')} - ${button.data('name')}` )

      const currentExtractId = button.data('id')

      global.extractId = currentExtractId

      global.getAllOsOfExtract({
        id: currentExtractId,
        notLinkedToOS: button.data('notlinked')
      })
    })

    // EXECUTA QUANDO MODAL EDITAR É FECHADO
    $('#myModal').on('hide.bs.modal', function () {
      global.alert.show = false

      if (global.reloadExtracts) {
        $('#search').trigger('click')
      }

      global.reloadExtracts = false
      global.reasonExtraValue = ''
      global.extraValueNotLinkedOs = 0
      global.extractId = undefined

      global.$store.dispatch('extract/clearFinishedOsFiltered')
    })

    // EXECUTA QUANDO MODAL UPLOAD É ACIONADO
    $('#modalUpload').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      const modal = $(this)
      modal.find('.modal-title').text(`Extrato ${button.data('whatever')} - Comprovante de Pagamento` )
      global.extractId = button.data('whatever')
    })

    // EXECUTA QUANDO MODAL EDITAR É FECHADO
    $('#modalUpload').on('hide.bs.modal', function (event) {
      global.file = null
      global.sendEmail = true
      global.alert.show = false
      if (global.reloadExtracts) $('#search').trigger('click')
      global.reloadExtracts = false
      global.extractId = undefined
    })

    // EXECUTA QUANDO MODAL ENVIAR/REENVIAR E-MAIL É ACIONADO
    $('#modalSendEmail').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      const modal = $(this)
      modal.find('.modal-title').text(`Extrato ${button.data('whatever')} - ${button.data('emailsent') ? 'Reenviar' : 'Enviar'} e-mail` )
      modal.find('#msgEmail').text(`Deseja ${button.data('emailsent') ? 'reenviar' : 'enviar'} e-mail à ${button.data('garage')}?`)
      global.extractId = button.data('whatever')
    })

    // EXECUTA QUANDO MODAL ENVIAR/REENVIAR E-MAIL É FECHADO
    $('#modalSendEmail').on('hide.bs.modal', function (event) {
      global.extractId = undefined
      global.alert.show = false
      if (global.reloadExtracts) $('#search').trigger('click')
      global.reloadExtracts = false
    })

    // EXECUTA QUANDO MODAL INFORMAÇÕES DE DADOS BANCÁRIOS E-MAIL É ACIONADO
    $('#modalInfo').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      const modal = $(this)
      modal.find('.modal-title').text(`${button.data('garage')} - Dados Bancários` )
      global.getBankData(button.data('whatever'))
    })

    $('#modalInfo').on('hide.bs.modal', function (event) {
      global.$store.dispatch('bankaccount/cleanState')
    })

    $('#modalLoading').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)
      const modal = $(this)

      button.data('evt') === 'paymentVoucher'
        ? global.getPaymentVoucher(button.data('whatever'))
        : global.printExtract(button.data('whatever'))
    })

  },

  destroyed() {
    const { dispatch } = this.$store

    dispatch('extract/cleanState')
    dispatch('bankaccount/cleanState')
    dispatch('garageaccredited/cleanState')
    dispatch('users/cleanState')
    dispatch('contracts/cleanState')
  }
}
</script>
